import { Component, EventEmitter, Input, Output } from '@angular/core';
import { AuthService } from 'src/app/Service/auth.service';

@Component({
    selector: 'team-popup',
    template: `<div class="modal-lg">
      <div class="modal-content">
        <div class="modal-body bios-modal-body">
          <button type="button" (click)="onCancel.emit(true)" class="btn-close" data-bs-dismiss="modal"
          aria-label="Popup close"></button>
          <div class="brief-bios-wrapper advisor-bios d-flex">
            <div class="bios-image">
              <img class="d-none d-md-block" src={{teamMemeber.image}} alt={{teamMemeber.name}}>
              <img class="d-block d-md-none" src={{teamMemeber.mobileImage}} alt={{teamMemeber.name}}>
            </div>
            <div class="bios-text">
              <h3>{{teamMemeber.name}}</h3>
              <h4>{{teamMemeber.description}}</h4>
              @for (info of teamMemeber.information; track info) {
                <p>
                  {{info}}
                </p>
              }
            </div>
          </div>
        </div>
      </div>
    </div>`,
    styleUrls: ['../team.component.css'],
    standalone: false
})
export class TeamPopUpComponent {
    @Output() onCancel = new EventEmitter();
    @Input() teamMemeber: any = [];
    constructor(public auth: AuthService) { }
}
